module.exports = __webpack_public_path__ + "static/media/Adobe.ff5b2ba8.png";